module.exports = __webpack_public_path__ + "1d0128d503527d38e659c40c449449e7.svg";